import React from 'react';
import { POS } from './layout';
import { placeTL, fonts, benefitsByLevel } from './ui';

/** 到期日顯示用：yyyy/mm/dd */
function formatLockerExpiry(val) {
  if (!val) return '';
  const s = typeof val === 'string' ? val : (val && val.toISOString ? val.toISOString() : '');
  const ymd = s.split('T')[0] || s.slice(0, 10) || '';
  return ymd ? ymd.replace(/-/g, '/') : '';
}

export default function CardInfo({ px, profile, night }) {
  const zTop  = { zIndex: 2 };
  const L0 = POS.infoTop;         // 密碼
  const L1 = POS.infoTop + 70;   // 個人櫃
  const L2 = POS.infoTop + 140;  // 電話
  const L3 = POS.infoTop + 210;  // 信箱
  const lockerNum = night?.lockerNumber ?? profile?.lockerNumber ?? '';
  const lockerExpiry = night?.lockerExpiry ?? profile?.lockerExpiry;
  const lockerExpired = Boolean(night?.lockerExpired ?? profile?.lockerExpired);
  const hasLocker = Boolean(lockerNum);

  const legacyRule = Boolean(
    night?.hasSearchedToday &&
    night?.isMember &&
    night?.password
  );
  const notExpired = night?.notExpired !== false;
  const showPassword = Boolean(
    night?.password &&
    notExpired &&
    (night?.shouldShowPassword ?? legacyRule)
  );

  // 調試信息（幫助診斷密碼顯示問題）
  if (night && !night.loading) {
    console.log('[CardInfo] 密碼顯示檢查:', {
      password: night?.password ? '有' : '無',
      notExpired,
      shouldShowPassword: night?.shouldShowPassword,
      legacyRule,
      hasSearchedToday: night?.hasSearchedToday,
      isMember: night?.isMember,
      showPassword,
      nightData: night
    });
  }

  return (
    <>
      {/* 密碼 Password（僅符合條件才顯示） */}
      {showPassword && (
        <div style={{ ...placeTL(px, 450, L0, fonts.info), ...zTop }}>
          {night.password}
        </div>
      )}

      {/* 個人櫃 Locker：第二行顯示 x號櫃 xxxx/xx/xx */}
      <div style={{
        ...placeTL(px, 450, L1, fonts.info),
        ...zTop,
        ...(hasLocker && lockerExpired ? { color: '#b00020', fontWeight: 700 } : {}),
      }}>
        {hasLocker ? `${lockerNum}號櫃 ${formatLockerExpiry(lockerExpiry)}` : '-'}
      </div>

      {/* 電話 Mobile / 信箱 Email */}
      <div style={{ ...placeTL(px, 450, L2, fonts.info), ...zTop }}>
        {profile?.PHONE || '-'}
      </div>
      <div style={{ ...placeTL(px, 450, L3, fonts.info), ...zTop }}>
        {profile?.EMAIL || '-'}
      </div>
      {/*<div style={{ ...placeTL(px, 420, L3, fonts.info), ...zTop }}>
        {benefitsByLevel(profile?.LEVEL)}
      </div>*/}
    </>
  );
}
